import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@app/core';
import { ReplaySubject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-pick-history',
  templateUrl: './pick-history.component.html',
  styleUrls: ['./pick-history.component.scss'],
})
export class PickHistoryComponent implements OnInit {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  history: any = [];
  @Input() userId: any = null;
  filter = new HttpParams().set('page', false).set('limit', 15);
  selectedSport = '';
  user = '';
  constructor(private _user: UserService, private _activated: ActivatedRoute) { }

  ngOnInit(): void {
    this._activated.parent?.data.pipe(takeUntil(this.destroyed$)).subscribe(async (data) => {
      let sport = data['sport'] || '';
      let id = data['userId'];
      this.filter = this.filter.set('skip', 0);
      this.filter = this.filter.set('user_id', id).set('sports', sport);
      let res = await this._user.pickHistory(this.filter);
      this.history = res.data;
      let limit: any = this.filter.get('limit');
      this.filter = this.filter.set('page', res.data.length == limit);
      this.selectedSport = sport;
      this.user = res.user;
    });
  }

  async loadMore(element: any) {
    if (element) {
      element.innerHTML =
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
    }
    this.filter = this.filter.set('skip', this.history.length);
    let res = await this._user.pickHistory(this.filter);
    let limit: any = this.filter.get('limit');
    this.filter = this.filter.set('page', res.data.length == limit);
    this.history.push(...res.data);
    if (element) {
      element.innerHTML = 'Load More';
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
